import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers/index';
import { initStatistics } from '../../../containers/Gallery/actions';
import { initGDPR, acceptAll, denyAll, openPanel, addBannerOpenListener, addBannerCloseListener } from '../../../utils/GDPRApi';
import { closeGDPRBanner, openGDPRBanner } from '../../../containers/CookieNotification/GDPRCookie/actions';
import { Translate } from 'react-redux-i18n';
import {
	Container, Message, Group, ButtonAllowAll,
	ButtonPersonalize, ButtonPrivacyPolicy, ButtonRejectAll
} from './styles';

interface GDPRCookieProps {
	shouldInit: boolean;
	isDisplayed: boolean;
	url: string;
	language: string;
	dispatch: Dispatch<StoreState>;
}

const GDPRCookie = ({
	shouldInit,
	isDisplayed,
	url,
	language,
	dispatch,
}: GDPRCookieProps) => {
	const openPrivacyPolicy = () => window.open(url, '_blank');

	React.useEffect(() => {
		addBannerCloseListener(() => dispatch(closeGDPRBanner()));
		addBannerOpenListener(() => dispatch(openGDPRBanner()));
		if (shouldInit) {
			initGDPR(language, url, () => dispatch(initStatistics()));
		}
	}, [shouldInit]);

	return (
		<Container isDisplayed={isDisplayed}>
			<Message><Translate value="messages.gdpr_message"/></Message>
			<Group>
				<ButtonAllowAll onClick={acceptAll}><Translate value="messages.gdpr_allowAll" /></ButtonAllowAll>
				<ButtonPersonalize onClick={openPanel}><Translate value="messages.gdpr_personalize" /></ButtonPersonalize>
			</Group>
			<Group>
				<ButtonPrivacyPolicy onClick={openPrivacyPolicy}><Translate value="messages.gdpr_privacy_policy" /></ButtonPrivacyPolicy>
				<ButtonRejectAll onClick={denyAll}><Translate value="messages.gdpr_reject_all" /></ButtonRejectAll>
			</Group>
		</Container>
	);
};

export default GDPRCookie;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CookieNotification/GDPRCookie/index.tsx